/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateUserDto { 
    email: string;
    name: string;
    lastName: string;
    password: string;
    isActive?: boolean;
    assignedLocations?: Array<number> | null;
    roles?: Array<string> | null;
}

